import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import { HiOutlineArrowLeft, HiOutlineExclamationTriangle } from 'react-icons/hi2'

// Role labels already translated for the connection-request screen.
const ROLE_KEYS = {
  admin: 'dashboard.connections.roleAdmin',
  diamond: 'dashboard.connections.roleDiamond',
  gold: 'dashboard.connections.roleGold',
  silver: 'dashboard.connections.roleSilver',
}

const WorkspaceBanner = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { ownerAccountName, switchedRole, clearWorkspace } = useAuth()

  const roleKey = ROLE_KEYS[String(switchedRole || '').toLowerCase()]

  const handleReturnToOwnAccount = () => {
    clearWorkspace()
    navigate('/dashboard')
  }

  return (
    <div className="workspace-banner flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <HiOutlineExclamationTriangle className="w-5 h-5 flex-shrink-0" />
        <div className="min-w-0">
          {/* Show the workspace name as-is: older names already end in "'s Account". */}
          <span className="font-medium">
            {t('workspaceBanner.youAreIn')} <strong>{ownerAccountName}</strong>
          </span>
          {roleKey && (
            <span className="ms-2 px-2 py-0.5 rounded-full bg-white/20 text-xs font-semibold whitespace-nowrap">
              {t('workspaceBanner.role', { role: t(roleKey) })}
            </span>
          )}
          <span className="hidden sm:inline ms-2 opacity-90">
            • {t('workspaceBanner.accessHint')}
          </span>
        </div>
      </div>

      <button
        onClick={handleReturnToOwnAccount}
        className="flex items-center gap-2 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-lg text-sm font-medium transition-colors flex-shrink-0"
      >
        <HiOutlineArrowLeft className="w-4 h-4 rtl:rotate-180" />
        <span className="hidden sm:inline">{t('workspaceBanner.return')}</span>
        <span className="sm:hidden">{t('workspaceBanner.returnShort')}</span>
      </button>
    </div>
  )
}

export default WorkspaceBanner
